import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

const firstChild = document.head.firstChild;
const metaTag = document.createElement('meta');
metaTag.setAttribute('name', 'robots');
metaTag.setAttribute('content', 'noindex, nofollow');
document.head.insertBefore(metaTag, firstChild);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

